import { validateVerificationCodeRoute } from "@api-routes/eirSalesFacade";
import { useFetch } from "@hooks/useFetch";
import { useState } from "react";
import type { FieldName, FieldValues, UseFormMethods } from "react-hook-form";
import { PortInStep } from "../portInStep";

interface IParams<TFieldValues extends FieldValues = FieldValues> {
    validationCodeValue: string;
    phoneNumberSelected: string;
    formMethods: UseFormMethods<TFieldValues>;
    namePrefix?: string;
    updatePortInStep(nextStep: PortInStep): void;
    setIsFinished(newValue: boolean): void;
    setHasTooManyAttempt(hasTooManyAttempt: boolean): void;
}

export const useValidationCode = <TFieldValues extends FieldValues = FieldValues>(props: IParams<TFieldValues>) => {
    const {
        validationCodeValue,
        phoneNumberSelected,
        formMethods,
        namePrefix,
        updatePortInStep,
        setIsFinished,
        setHasTooManyAttempt,
    } = props;
    const [validateCodeState, { post }] = useFetch();

    const [userAttempt, setUserAttempt] = useState(0);

    const incrementUserAttempt = () => {
        setUserAttempt((prevState) => prevState + 1);
    };

    const resetUserAttempt = () => {
        setUserAttempt(0);
    };

    const validateCode = async (): Promise<void> => {
        const validationCodeFieldName = namePrefix ? `${namePrefix}validationCode` : "validationCode";
        if (await formMethods.trigger(validationCodeFieldName as FieldName<TFieldValues>)) {
            const payload = {
                msisdn: phoneNumberSelected,
                otp: validationCodeValue,
            };

            try {
                await post(validateVerificationCodeRoute(), {
                    body: payload,
                    forwardError: true,
                });
                updatePortInStep(PortInStep.successCode);
                setIsFinished(true);
            } catch {
                if (userAttempt < 2) {
                    incrementUserAttempt();
                } else {
                    resetUserAttempt();
                    setHasTooManyAttempt(true);
                    updatePortInStep(PortInStep.getCode);
                }
            }
        }
    };

    return { validateCodeState, validateCode };
};
